import React from "react";
import { Link } from "react-router-dom";
import { styled } from "../../../stitches.config";
import { bodyLarge } from '../../commonStyles/Fonts';

type MailButtonProps = {
    mailto: string;
    label: string;
}

const MailButton = ({ mailto, label }: MailButtonProps) => {
    return (
        <StyledButton
            onClick={(e) => {
                window.location.href = mailto;
                e.preventDefault();
            }}
        >
            <span className={bodyLarge()}>{label}</span>
        </StyledButton>
    );
};

export default MailButton;

const StyledButton = styled('button', {
    width: '100%',
    backgroundColor: '$primary',
    color: '$grayscale0Fixed',
    border: 'none',
    height: '48px',
    textAlign: 'center',
    fontSize: '16px',
    lineHeight: '24px',
})
